import { Card, Heading, Text } from '@components'
import type { Setup } from '@here/api'
import type { ParentComponent } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'
import { useSingle } from '../state'

interface HeaderProps {
	setup: Setup
}

const Header: ParentComponent<HeaderProps> = (props) => {
	const { takenResource, subscribed } = useService(useSingle)()

	return (
		<Card.Root
			p={4}
			display={{
				base: 'none',
				mdDown: 'flex',
			}}
			flexDirection="row"
			justifyContent="space-between"
		>
			<Grid
				gap={2}
				alignItems="center"
				justifyContent="space-between"
			>
				<Heading textTransform="capitalize">{props.setup.title}</Heading>
				<Text>{props.setup.symbol}</Text>
			</Grid>
			<Grid
				gap={2}
				alignItems="center"
				justifyContent="space-between"
				textAlign="right"
			>
				<Text size="sm">
					{subscribed() ? 'setup subscribed' : 'setup not subscribed'}
				</Text>
				<Text size="sm">
					{takenResource()?.has_taken ? 'setup Taken' : 'setup not taken'}
				</Text>
			</Grid>
		</Card.Root>
	)
}

export default Header
